import React from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import WhyUs from "@/components/WhyUs";
import Catalog from "@/components/Catalog";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import FloatingWA from "@/components/FloatingWA";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <About />
        <WhyUs />
        <Catalog />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
      <FloatingWA />
    </div>
  );
}

export default App;
